import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'lyceo-ui-modal-header',
  imports: [FaIconComponent],
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHeaderComponent {
  public readonly text: InputSignal<string> = input.required();
  public readonly closeModal: OutputEmitterRef<void> = output();

  protected faXmark: IconDefinition = faXmark;
}
